import { useCallback } from 'react';
import { toggleTimelineCollapsed } from '../state/actions/toggle-timeline-collapsed';
import { saveTimelineCollapsed } from '../state/timeline-collapsed-persistance';
import { useTimelineCollapsed, useWriteContext } from '../utils/use-context';
import { ToolButton } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { Bottompanelclose, Bottompanelopen } from '@crabs-ai/web-icons';

export function TimelineCollapseToggle() {
  const t = useTranslations();
  const writeContext = useWriteContext();
  const isTimelineCollapsed = useTimelineCollapsed();

  const handleToggle = useCallback(() => {
    writeContext.setState({
      update: (state) => {
        const newState = toggleTimelineCollapsed(state);
        saveTimelineCollapsed(newState.isTimelineCollapsed);
        return newState;
      },
      commitToUndoStack: false,
    });
  }, [writeContext]);

  const label = isTimelineCollapsed
    ? t('Editor.timeline-controls.timeline-open')
    : t('Editor.timeline-controls.timeline-close');

  return (
    <ToolButton
      size="sm"
      isTransparent={false}
      state="default"
      onClick={handleToggle}
      aria-label={label}
      aria-pressed={isTimelineCollapsed}
    >
      {isTimelineCollapsed ? (
        <Bottompanelopen className="size-5" />
      ) : (
        <Bottompanelclose className="size-5" />
      )}
      {label}
    </ToolButton>
  );
}
